import { render, staticRenderFns } from "./frontdesk.vue?vue&type=template&id=234940d1&scoped=true"
import script from "./frontdesk.vue?vue&type=script&lang=js"
export * from "./frontdesk.vue?vue&type=script&lang=js"
import style0 from "./frontdesk.vue?vue&type=style&index=0&id=234940d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234940d1",
  null
  
)

export default component.exports